import { render, staticRenderFns } from "./EditSnps.vue?vue&type=template&id=01349cca&scoped=true&"
import script from "./EditSnps.vue?vue&type=script&lang=js&"
export * from "./EditSnps.vue?vue&type=script&lang=js&"
import style0 from "./EditSnps.vue?vue&type=style&index=0&id=01349cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01349cca",
  null
  
)

export default component.exports